import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import FormInput from '../../components/FormInput';
import FormLabel from '../../components/FormLabel';
import SimpleButton from '../../components/SimpleButton';
import Spacer from '../../components/Spacer';
import { IApplicationState } from '../../store';
import { sweepDraftUpdate, sweepsSaveRequest } from '../../store/sweeps/slice';
import { ISweep } from '../../store/sweeps/types';
import { Container } from './styles';

const SweepForm: React.FC = (props) => {
    const route = useMatch('/sweep/:idSweep/form');

    const
        { t } = useTranslation();

    const idSweep = route?.params.idSweep;

    const sweep = useSelector((state: IApplicationState) => state.sweeps.data.find(sweep => sweep.id === idSweep))

    const sweeps = useSelector((state: IApplicationState) => state.sweeps);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);

    const editingSweep = sweeps.draftSweep;

    const setEditingSweep = useCallback((sweep: ISweep) => {
        dispatch(sweepDraftUpdate(sweep))
    }, [dispatch])

    useEffect(() => {
        if (sweep && !isLoaded) {
            setEditingSweep({
                ...sweep,
                error: undefined
            })
            setIsLoaded(true)
        }
    }, [sweep, isLoaded, setEditingSweep])

    if (!editingSweep) {
        return <Container>
            <h1>{t("pages.sweeps.not_found_form")}</h1>
        </Container>
    }

    return <Container>
        <h1>{sweep ? t("pages.sweeps.edit_sweep") : t("pages.sweeps.create_sweep")}</h1>

        <FormLabel>{t("pages.sweeps.sweep_name")}</FormLabel>
        <FormInput
            value={editingSweep?.name || ""}
            onChangeText={(text) => {
                setEditingSweep({
                    ...editingSweep,
                    name: text
                })
            }}
        />

        <FormLabel>{t("pages.sweeps.customer")}</FormLabel>
        <FormInput
            value={editingSweep?.customer || ""}
            onChangeText={(text) => {
                setEditingSweep({
                    ...editingSweep,
                    customer: text
                })
            }}
        />

        <FormLabel>{t("pages.sweeps.address")}</FormLabel>
        <FormInput
            value={editingSweep?.address || ""}
            onChangeText={(text) => {
                setEditingSweep({
                    ...editingSweep,
                    address: text
                })
            }}
        />

        <FormLabel>{t("pages.sweeps.report_number")}</FormLabel>
        <FormInput
            value={editingSweep?.reportNumber || ""}
            onChangeText={(text) => {
                setEditingSweep({
                    ...editingSweep,
                    reportNumber: text
                })
            }}
        />

        <FormLabel>{t("pages.sweeps.version")}</FormLabel>
        <FormInput
            value={editingSweep?.version || ""}
            onChangeText={(text) => {
                setEditingSweep({
                    ...editingSweep,
                    version: text
                })
            }}
        />

        <Spacer size={20} />

        <SimpleButton
            prependIcon='save'
            color='primary'
            disabled={editingSweep?.isSaving || sweeps.isLoading}
            onClick={() => {
                dispatch(sweepsSaveRequest(editingSweep))
            }}>
            {editingSweep?.isSaving ? `${t("common.buttons.saving")}...` : t("common.buttons.save")}
        </SimpleButton>

        <Spacer size={20} />

        {editingSweep?.error && <React.Fragment>
            <ErrorMessage>{editingSweep.error.message}</ErrorMessage>
            <Spacer size={20} />
        </React.Fragment>}
    </Container>;
}

export default SweepForm;